/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getAppointments } from 'app/entities/appointments/appointments.reducer';
import { getEntities as getPatientProcedureEpisodes } from 'app/entities/patient-procedure-episode/patient-procedure-episode.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './appointment-episode.reducer';

export const AppointmentEpisodeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const appointments = useAppSelector(state => state.appointments.entities);
  const patientProcedureEpisodes = useAppSelector(state => state.patientProcedureEpisode.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const appointmentEpisodeEntity = useAppSelector(state => state.appointmentEpisode.entity);
  const loading = useAppSelector(state => state.appointmentEpisode.loading);
  const updating = useAppSelector(state => state.appointmentEpisode.updating);
  const updateSuccess = useAppSelector(state => state.appointmentEpisode.updateSuccess);
  const addedByTypeValues = Object.keys(AddedByType);

  const handleClose = () => {
    navigate(`/appointment-episode${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getAppointments({}));
    dispatch(getPatientProcedureEpisodes({}));
    dispatch(getHospitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.expectedStartTime !== undefined && typeof values.expectedStartTime !== 'number') {
      values.expectedStartTime = Number(values.expectedStartTime);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...appointmentEpisodeEntity,
      ...values,
      appointment: appointments.find(it => it.id.toString() === values.appointment?.toString()),
      episode: patientProcedureEpisodes.find(it => it.id.toString() === values.episode?.toString()),
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          addedByType: 'DOCTOR',
          modifiedByType: 'DOCTOR',
          ...appointmentEpisodeEntity,
          appointment: appointmentEpisodeEntity?.appointment?.id,
          episode: appointmentEpisodeEntity?.episode?.id,
          hospital: appointmentEpisodeEntity?.hospital?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.appointmentEpisode.home.createOrEditLabel" data-cy="AppointmentEpisodeCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.appointmentEpisode.home.createOrEditLabel">
              Create or edit a AppointmentEpisode
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="appointment-episode-id"
                  label={translate('tinyMedicRestApp.appointmentEpisode.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.appointmentEpisode.expectedStartTime')}
                id="appointment-episode-expectedStartTime"
                name="expectedStartTime"
                data-cy="expectedStartTime"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.appointmentEpisode.active')}
                id="appointment-episode-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.appointmentEpisode.cursor')}
                id="appointment-episode-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.appointmentEpisode.lastupdated')}
                id="appointment-episode-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.appointmentEpisode.microSec')}
                id="appointment-episode-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.appointmentEpisode.timestampentry')}
                id="appointment-episode-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.appointmentEpisode.notes')}
                id="appointment-episode-notes"
                name="notes"
                data-cy="notes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.appointmentEpisode.addedById')}
                id="appointment-episode-addedById"
                name="addedById"
                data-cy="addedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.appointmentEpisode.modifiedById')}
                id="appointment-episode-modifiedById"
                name="modifiedById"
                data-cy="modifiedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.appointmentEpisode.addedByType')}
                id="appointment-episode-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.appointmentEpisode.modifiedByType')}
                id="appointment-episode-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="appointment-episode-appointment"
                name="appointment"
                data-cy="appointment"
                label={translate('tinyMedicRestApp.appointmentEpisode.appointment')}
                type="select"
              >
                <option value="" key="0" />
                {appointments
                  ? appointments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="appointment-episode-episode"
                name="episode"
                data-cy="episode"
                label={translate('tinyMedicRestApp.appointmentEpisode.episode')}
                type="select"
              >
                <option value="" key="0" />
                {patientProcedureEpisodes
                  ? patientProcedureEpisodes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="appointment-episode-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.appointmentEpisode.hospital')}
                type="select"
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/appointment-episode" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AppointmentEpisodeUpdate;
